import { yandexTrackingService } from './YandexTrackingService';
import { SearchGoal } from '../model/dataLayerEvents';

export function trackFlexibleDaysClick(daysFlexible: number): void {
  if (typeof window === 'undefined' || daysFlexible <= 0) return;

  yandexTrackingService.setTrackingGoal(SearchGoal.FlexibleDaysClick, 'click', { daysFlexible });
}

export function trackEmptySearch(): void {
  if (typeof window === 'undefined') return;

  yandexTrackingService.setTrackingGoal(SearchGoal.EmptySearch, 'other');
}
